// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__c-80R","bannerIcons":"Banner_bannerIcons__18ae5"};